"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Filter = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _material = require("@mui/material");
var _paulCorePackage = require("paul-core-package");
var _ExpandMore = _interopRequireDefault(require("@mui/icons-material/ExpandMore"));
var _constants = require("../../../../../utils/constants");
var _actions = require("../../../../../redux/actions");
var _FilterItem = require("./FilterItem");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  colors
} = _paulCorePackage.constants;
const accordionKey = 'filter_temperature';
const minWidthForDefShow = 1440;
const minHeightForDefShow = 800;
/** @todo remove translation number key */
const Filter = exports.Filter = /*#__PURE__*/(0, _react.memo)(() => {
  const dispatch = (0, _reactRedux.useDispatch)();
  const defaultCloseAccordion = _paulCorePackage.functions.isMobile || window.innerWidth < minWidthForDefShow || window.innerHeight < minHeightForDefShow;
  const [expanded, setExpanded] = (0, _react.useState)(defaultCloseAccordion ? null : accordionKey);
  const handleChange = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const setFiltersFunc = (0, _react.useCallback)(event => {
    const {
      name,
      checked
    } = event.target;
    dispatch((0, _actions.updateFiltration)({
      name,
      value: checked
    }));
  }, [dispatch]);
  const {
    1: title
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUILocalizations);
  return /*#__PURE__*/_react.default.createElement(_material.Card, {
    sx: {
      pointerEvents: 'auto',
      boxShadow: _constants.styles.boxShadow.primary,
      minWidth: '260px',
      borderRadius: '10px'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Accordion, {
    expanded: expanded === accordionKey,
    onChange: handleChange(accordionKey)
  }, /*#__PURE__*/_react.default.createElement(_material.AccordionSummary, {
    expandIcon: /*#__PURE__*/_react.default.createElement(_ExpandMore.default, {
      sx: {
        color: colors['main-color-cl-01']
      }
    }),
    sx: {
      minHeight: '40px',
      '&.Mui-expanded': {
        minHeight: '40px'
      },
      '.MuiAccordionSummary-content': {
        margin: '15px 0'
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: {
      fontWeight: 'bold',
      fontSize: '18px',
      color: colors['main-color-cl-01']
    }
  }, title !== null && title !== void 0 ? title : /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
    variant: "text",
    sx: {
      fontSize: 'inherit',
      width: 120
    }
  }))), /*#__PURE__*/_react.default.createElement(_material.AccordionDetails, {
    sx: {
      pt: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_material.FormGroup, {
    name: "defineFiltersGroup",
    onChange: setFiltersFunc
  }, _constants.filterList.map(item => /*#__PURE__*/_react.default.createElement(_FilterItem.FilterItem, {
    key: item.key,
    item: item
  }))))));
});